module.exports = __webpack_public_path__ + "img/InesWestberg_140x140.f5e3c92b.jpg";